export const ATTEMPT_TOKEN_HEADER = "X-Attempt-Token";

let attemptToken = null;

export function captureAttemptToken(responseData) {
    attemptToken = responseData?.[0]?.attemptToken ?? null;
    return attemptToken;
}

export function getAttemptToken() {
    return attemptToken;
}

export function setAttemptToken(value) {
    attemptToken = value ?? null;
}

export function withAttemptToken(headers) {
    if (!attemptToken) return headers;
    return {...headers, [ATTEMPT_TOKEN_HEADER]: attemptToken};
}
